import {Injectable, Injector} from '@angular/core';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {User} from '../../../api/entity/user.model';
import {EntityCollectionServiceElementsFactory} from "@ngrx/data";



@Injectable({providedIn: 'root'})
export class UserRepository extends AbstractRepositoryV2<User>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('User', serviceElementsFactory, injector);
    }
}
